var _ = Object.defineProperty;
var T = (c, t, e) => (t in c ? _(c, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : (c[t] = e));
var S = (c, t, e) => (T(c, typeof t != "symbol" ? t + "" : t, e), e);
import { u as E, S as v } from "./g-atc-form.5be2ff54.chunk.js";
function f(c, t) {
  typeof c == "string" && (c = c.replace(".", ""));
  let e = "";
  const i = /\{\{\s*(\w+)\s*\}\}/,
    s =
      t || window.storeVariables.currency_code_enabled
        ? window.storeVariables.money_with_currency_format
        : window.storeVariables.money_format;
  function n(r, a) {
    return typeof r > "u" ? a : r;
  }
  function o(r, a, l, h) {
    if (((a = n(a, 2)), (l = n(l, ",")), (h = n(h, ".")), isNaN(r) || r == null)) return 0;
    r = (r / 100).toFixed(a);
    const d = r.split("."),
      p = d[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${l}`),
      m = d[1] ? h + d[1] : "";
    return p + m;
  }
  switch (s.match(i)[1]) {
    case "amount":
      e = o(c, 2);
      break;
    case "amount_no_decimals":
      e = o(c, 0);
      break;
    case "amount_with_comma_separator":
      e = o(c, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      e = o(c, 0, ".", ",");
      break;
  }
  return s.replace(i, e);
}
class y {
  static load(t) {
    if (t)
      return this.loadedProducts[t]
        ? this.loadedProducts[t]
        : ((this.loadedProducts[t] = new Promise(async (e) => {
            const s = await (await fetch(`${window.Shopify.routes.root}products/${t}.js`)).json();
            e(s);
          })),
          this.loadedProducts[t]);
  }
}
S(y, "loadedProducts", {});
class A extends HTMLInputElement {
  connectedCallback() {
    this.addEventListener("input", this._onValueInput.bind(this)),
      this.addEventListener("change", this._onValueChanged.bind(this)),
      this.addEventListener("keydown", this._onKeyDown.bind(this));
  }
  get quantity() {
    return parseInt(this.value);
  }
  set quantity(t) {
    const e = (typeof t == "number" || (typeof t == "string" && t.trim() !== "")) && !isNaN(t);
    t !== "" &&
      ((!e || t < 0) && (t = parseInt(t) || 1),
      (this.value = Math.max(this.min || 1, Math.min(t, this.max || Number.MAX_VALUE)).toString()),
      this.setAttribute("value", this.value),
      (this.size = Math.max(this.value.length + 1, 2)),
      console.log("this.form", this.form),
      this.form &&
        this.form.dispatchEvent(
          new CustomEvent("quantity:changed", { bubbles: !1, detail: { newQuantity: this.quantity } })
        ));
  }
  _onValueInput() {
    this.quantity = this.value;
  }
  _onValueChanged() {
    this.value === "" && (this.quantity = 1);
  }
  _onKeyDown(t) {
    t.stopPropagation(),
      t.key === "ArrowUp"
        ? (this.quantity = this.quantity + 1)
        : t.key === "ArrowDown" && (this.quantity = this.quantity - 1);
  }
}
customElements.define("input-number", A, { extends: "input" });
class w extends HTMLElement {
  constructor() {
    super(),
      this._setBoxBusy(!0),
      this.insertAdjacentHTML(
        "afterbegin",
        `
      <div class="combo-box-selected"></div>
      <div class="combo-box-items combo-box-hide"></div>
    `
      ),
      (this.selectedDiv = this.querySelector(".combo-box-selected")),
      (this.itemsDiv = this.querySelector(".combo-box-items"));
  }
  connectedCallback() {
    const t = this.querySelector("select");
    (this.selectedDiv.textContent = t.options[t.selectedIndex].textContent),
      Array.from(t.options).forEach((e, i) => {
        const s = document.createElement("div");
        (s.textContent = e.textContent),
          s.setAttribute("data-index", i),
          s.addEventListener("click", () => {
            (t.selectedIndex = i),
              (t.value = e.value),
              (this.selectedDiv.textContent = e.textContent),
              this.updateSelected(i),
              this.toggleDropdown(),
              t.dispatchEvent(new Event("change"));
          }),
          this.itemsDiv.appendChild(s);
      }),
      this.updateSelected(t.selectedIndex),
      this.selectedDiv.addEventListener("click", () => {
        this.toggleDropdown();
      }),
      document.addEventListener("click", (e) => {
        this.contains(e.target) || this.closeAllSelect();
      }),
      this._setBoxBusy(!1);
  }
  updateSelected(t) {
    const e = this.itemsDiv.querySelector(`[data-index="${t}"]`);
    this.itemsDiv.querySelectorAll(".same-as-selected").forEach((i) => {
      i.classList.remove("same-as-selected");
    }),
      e && e.classList.add("same-as-selected");
  }
  toggleDropdown() {
    this.itemsDiv.classList.toggle("combo-box-hide"), this.selectedDiv.classList.toggle("active");
  }
  _setBoxBusy(t = !1) {
    this.setAttribute("aria-busy", t.toString());
  }
  closeAllSelect() {
    this.itemsDiv.classList.add("combo-box-hide"), this.selectedDiv.classList.remove("active");
  }
}
customElements.define("combo-box", w);
class b extends HTMLElement {
  constructor() {
    super();
  }
  async init() {
    var t;
    (this.form = document.getElementById(this.getAttribute("data-form-id"))),
      (this.masterSelector = (t = this.form) == null ? void 0 : t.id),
      (this.product = await y.load(this.productHandle));
  }
  get selectedVariant() {
    return this.getVariantById(parseInt(this.masterSelector.value));
  }
  get productHandle() {
    var t, e;
    return (e = (t = this.form) == null ? void 0 : t.handle) == null ? void 0 : e.value;
  }
  getVariantById(t) {
    return this.product.variants.find((e) => e.id === t);
  }
}
class C extends b {
  constructor() {
    super();
  }
  async connectedCallback() {
    await super.init(),
      (this.subscriptionBlock = document.querySelector(`subscription-block[data-form-id="${this.dataset.formId}"]`)),
      (this.price = this.querySelector("[data-price]")),
      (this.compareAtPrice = this.querySelector("[data-compare-at-price]")),
      (this.discount = this.querySelector("[data-discount]")),
      this.form &&
        (this.form.addEventListener("variant:changed", this._onVariantChanged.bind(this)),
        this.form.addEventListener("selling-plan:changed", this._updatePrice.bind(this)),
        this.quantityUpdate && this.form.addEventListener("quantity:changed", this._onQuantityChanged.bind(this)));
  }
  _updatePrice() {
    var n, o;
    let t, e;
    if (this.subscriptionBlock)
      switch (this.subscriptionBlock.selectedOfferType) {
        case "one-time":
          (t = parseInt(this.selectedVariant.price)), (e = parseInt(this.selectedVariant.compare_at_price));
          break;
        case "subscription":
          if (!this.subscriptionBlock.selectedSellingPlan) return;
          (t = parseInt(this.subscriptionBlock.selectedSellingPlan.price)),
            (e = parseInt(this.subscriptionBlock.selectedSellingPlan.compare_at_price));
          break;
      }
    else (t = parseInt(this.selectedVariant.price)), (e = parseInt(this.selectedVariant.compare_at_price));
    const i =
        ((o = (n = this.form) == null ? void 0 : n.querySelector) == null
          ? void 0
          : o.call(n, 'input[name="quantity"]')) ||
        (this.form && this.form.quantity && this.form.quantity[0]),
      s = (this.quantityUpdate && i && Number.parseInt(i.value)) || 1;
    console.log("qtyInput", i, s),
      (this.price.innerText = f(t * s)),
      e > t
        ? (this.classList.add("jc-compare-at-price"),
          (this.compareAtPrice.innerText = f(e * s)),
          this.discount && (this.discount.innerText = Math.floor(100 - (t / e) * 100)))
        : this.classList.remove("jc-compare-at-price");
  }
  _updateVideoSection(t) {
    const e = document.querySelector(".video-section");
    if (!e) return;
    e.querySelectorAll(".video-item").forEach((s) => {
      s.classList.toggle("hidden", s.id !== `pdp-video-${t.id}`);
    });
  }
  get quantityUpdate() {
    return this.dataset.quantityUpdate == "true";
  }
  _onVariantChanged(t) {
    this._updatePrice(), this._updateVideoSection(t.detail.variant);
  }
  _onQuantityChanged(t) {
    this._updatePrice();
  }
}
customElements.define("price-block", C);
class L extends HTMLFormElement {
  connectedCallback() {
    (this.submitButtons = Array.from(this.elements).filter((t) => t.type === "submit")),
      this.addEventListener("submit", this._onSubmit.bind(this)),
      this.submitButtons.forEach((t) => {
        t.addEventListener("click", this._onButtonClick.bind(this));
      }),
      this.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  async _onSubmit(t) {
    t.preventDefault();
    const e = this.clickedButton && this.clickedButton.getAttribute("data-buy-type") === "buy-now";
    if ((this._setButtonBusy(this.submitButtons, !0, !0), !this.checkValidity())) {
      this.reportValidity();
      return;
    }
    const i = new FormData(this);
    i.delete("option1"), i.delete("option2"), i.delete("option3");
    const { id: s, quantity: n, selling_plan: o } = this._extractFormData(i, ["id", "quantity", "selling_plan"]);
    if (!s) return;
    const r = await E.cart.addItem(s, n, [], o);
    if (r)
      this.dispatchEvent(new CustomEvent("variant:added", { detail: r, bubbles: !0, composed: !0 })),
        e && this._redirectToCheckout();
    else {
      this._setButtonBusy(this.submitButtons, !1);
      return;
    }
    this._setButtonBusy(this.submitButtons, !1);
  }
  _onVariantChanged(t) {
    this._updateAddToCartButtons(t.detail.variant);
  }
  _updateAddToCartButtons(t) {
    this.submitButtons.length < 1 ||
      this.submitButtons.forEach((e) => {
        let i = "",
          s = !0;
        t && t.available
          ? ((i = e.getAttribute("data-button-text") || "Add to cart"), (s = !1))
          : (i = e.getAttribute("data-sold-out-text") || "Sold out"),
          s ? e.setAttribute("disabled", "disabled") : e.removeAttribute("disabled"),
          (e.querySelector(".js-button-text").innerText = i);
      });
  }
  _onButtonClick(t) {
    this.clickedButton = t.currentTarget;
  }
  _redirectToCheckout() {
    window.location.href = "/checkout";
  }
  _extractFormData(t, e) {
    const i = {};
    for (const [s, n] of t.entries()) e.includes(s) && (i[s] = n);
    return i;
  }
  _setButtonBusy(t, e, i = !1) {
    t.forEach((s) => {
      (s.disabled = e), s.setAttribute("aria-busy", i.toString());
    });
  }
}
customElements.define("product-form", L, { extends: "form" });
class k extends b {
  constructor() {
    super(), (this._elementsToUpdate = [".variant-swatch label"]);
  }
  async connectedCallback() {
    if (
      (await super.init(),
      (this.optionSelectors = Array.from(this.querySelectorAll("[data-selector-type]"))),
      !this.masterSelector)
    ) {
      console.warn(
        `The variant selector for product with handle ${this.productHandle} is not linked to any product form.`
      );
      return;
    }
    document.querySelectorAll('[name^="option"]').forEach((t) => {
      t.addEventListener("change", (e) => {
        this._onOptionChanged.bind(this), this._updateOptionLegend(e.target);
      }),
        t.addEventListener("change", (e) => this._onOptionChanged(e));
    }),
      this.form.addEventListener("selling-plan:changed", this._onSellingPlanChanged.bind(this)),
      this.masterSelector.addEventListener("change", this._onMasterSelectorChanged.bind(this)),
      this._updateDisableSelectors(),
      this._selectVariant(this.selectedVariant.id);
  }
  _onSellingPlanChanged(t) {
    var o;
    const e = this._getVariantFromOptions(),
      i = e ? e.id : void 0,
      s = this.dataset.sectionId;
    (this.sellingPlan = t.detail.newSellingPlan),
      this._areElementsPresent() &&
        this._fetchData(this.productHandle, i, s, (o = this.sellingPlan) == null ? void 0 : o.selling_plan_id),
      this._updateThreeCardsSection(i);
  }
  _onOptionChanged(t) {
    var o;
    const e = this._getVariantFromOptions(),
      i = e ? e.id : void 0,
      s = this.dataset.sectionId,
      n = this._areElementsPresent();
    this._updateOptionLegend(t.target),
      this._selectVariant(i),
      n && this._fetchData(super.productHandle, i, s, (o = this.sellingPlan) == null ? void 0 : o.selling_plan_id),
      this._updateThreeCardsSection(i);
  }
  _updateOptionLegend(t) {
    const e = document.getElementById(t.getAttribute("data-bind-value"));
    e && (t.tagName === "SELECT" && (t = t.options[t.selectedIndex]), (e.innerHTML = t.value));
  }
  _onMasterSelectorChanged() {
    var t;
    (((t = this.selectedVariant) == null ? void 0 : t.options) || []).forEach((i, s) => {
      let n = this.querySelector(
          `input[name="option${s + 1}"][value="${CSS.escape(i)}"], select[name="option${s + 1}"]`
        ),
        o = !1;
      n.tagName === "SELECT"
        ? ((o = n.value !== i), (n.value = i))
        : n.tagName === "INPUT" && ((o = !n.checked && n.value === i), (n.checked = n.value === i)),
        o && n.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
  _selectVariant(t) {
    var e;
    if (
      (this._isVariantSelectable(super.getVariantById(t)) ||
        (t = this._getFirstMatchingAvailableOrSelectableVariant().id),
      ((e = this.selectedVariant) == null ? void 0 : e.id) === t)
    )
      return;
    if (
      ((this.masterSelector.value = t),
      this.masterSelector.dispatchEvent(new Event("change", { bubbles: !0 })),
      this.updateUrl && history.replaceState)
    ) {
      const r = new URL(window.location.href);
      t ? r.searchParams.set("variant", t) : r.searchParams.delete("variant"),
        window.history.replaceState({ path: r.toString() }, "", r.toString());
    }
    this._updateDisableSelectors(),
      this.masterSelector.form.dispatchEvent(
        new CustomEvent("variant:changed", { bubbles: !0, detail: { variant: this.selectedVariant } })
      );
    let i = document.getElementById("product-variants-json");
    if (!i) return;
    let s = document.querySelectorAll(".amazon-button");
    s.forEach((r) => {
      r.classList.add("pointer-events-none");
    });
    let o = JSON.parse(i.textContent).find((r) => r.id === this.selectedVariant.id);
    o &&
      o.amazon_url !== "" &&
      s.forEach((r) => {
        r.classList.remove("pointer-events-none"), (r.href = o.amazon_url);
      });
  }
  _getVariantFromOptions() {
    const t = this._getSelectedOptionValues();
    return this.product.variants.find((e) => e.options.every((i, s) => i === t[s]));
  }
  _isVariantSelectable(t) {
    return t ? t.available || (!this.hideSoldOutVariants && !t.available) : !1;
  }
  _getFirstMatchingAvailableOrSelectableVariant() {
    let t = this._getSelectedOptionValues(),
      e = null,
      i = 0;
    do
      t.pop(),
        (i += 1),
        (e = this.product.variants.find((s) =>
          this.hideSoldOutVariants
            ? s.available && s.options.slice(0, s.options.length - i).every((n, o) => n === t[o])
            : s.options.slice(0, s.options.length - i).every((n, o) => n === t[o])
        ));
    while (!e && t.length > 0);
    return e;
  }
  _getSelectedOptionValues() {
    const t = [];
    return (
      Array.from(this.querySelectorAll('input[name^="option"]:checked, select[name^="option"]')).forEach((e) =>
        t.push(e.value)
      ),
      t
    );
  }
_updateDisableSelectors() {
    const t = this.selectedVariant;
    if (!t) return;
    const e = (i, s, n, o) => {
      let r = i.getAttribute("data-selector-type"),
        a = "";
      switch (r) {
        case "color":
          a = `.color-swatch:nth-child(${s + 1})`;
          break;
        case "variant_swatch":
          a = `.variant-swatch:nth-child(${s + 1})`;
          break;
        case "checkbox":
          a = `.checkbox-swatch:nth-child(${s + 1})`;
          break;
        case "select":
          a = `.select__option-item:nth-child(${s + 1})`;
          break;
      }
      const el = i.querySelector(a);
      if (!el) return;
      el.toggleAttribute("hidden", !o);
      this.hideSoldOutVariants
        ? el.toggleAttribute("hidden", !n)
        : el.classList.toggle("is-disabled", !n);
    };
    this.optionSelectors &&
      this.optionSelectors[0] &&
      this.product.options[0].values.forEach((i, s) => {
        const n = this.product.variants.some((r) => r.option1 === i && r),
          o = this.product.variants.some((r) => r.option1 === i && r.available);
        e(this.optionSelectors[0], s, o, n),
          this.optionSelectors[1] &&
            this.product.options[1].values.forEach((r, a) => {
              const l = this.product.variants.some((d) => d.option2 === r && d.option1 === t.option1 && d),
                h = this.product.variants.some((d) => d.option2 === r && d.option1 === t.option1 && d.available);
              e(this.optionSelectors[1], a, h, l),
                this.optionSelectors[2] &&
                  this.product.options[2].values.forEach((d, p) => {
                    const m = this.product.variants.some(
                        (u) => u.option3 === d && u.option1 === t.option1 && u.option2 === t.option2 && u
                      ),
                      g = this.product.variants.some(
                        (u) => u.option3 === d && u.option1 === t.option1 && u.option2 === t.option2 && u.available
                      );
                    e(this.optionSelectors[2], p, g, m);
                  });
            });
      });
  }
  _areElementsPresent() {
    let t = !1;
    return (
      this._elementsToUpdate.forEach((e) => {
        document.querySelector(e) && (t = !0);
      }),
      t
    );
  }
  async _fetchData(t, e, i, s) {
    try {
      s || (s = "one-time");
      let n = `${window.Shopify.routes.root}products/${t}?variant=${e}&section_id=${i}&selling_plan=${s}`;
      const o = await fetch(n);
      if (!o.ok) throw new Error(`Failed to fetch product: ${o.statusText}`);
      const r = await o.text(),
        l = new DOMParser().parseFromString(r, "text/html");
      this._elementsToUpdate.forEach((h) => this._updateData(h, l)), this._updateQuantityRules(l);
    } catch (n) {
      console.error(`An error occurred: ${n}`);
    }
  }
  _updateData(t, e) {
    const i = document.querySelectorAll(t),
      s = e.querySelectorAll(t);
    i.forEach((n, o) => {
      o < s.length && (n.innerHTML = s[o].innerHTML);
    });
  }
  _updateQuantityRules(t) {
    const e = document.querySelector("quantity-selector"),
      i = t.querySelector("quantity-selector input");
    !e || !i || (e.max = +i.getAttribute("max"));
  }
  async _updateThreeCardsSection(t) {
    try {
      const e = document.querySelector(".three-cards-main-block");
      if (!e) return;
      const i = e.closest('[id^="shopify-section-"]');
      if (!i) {
        console.warn("Three cards section ID not found");
        return;
      }
      const s = i.id.replace("shopify-section-", "");
      if (!s) {
        console.warn("Could not extract section ID for three cards");
        return;
      }
      const n = super.productHandle;
      if (!n || !t) return;
      const o = `${window.Shopify.routes.root}products/${n}?variant=${t}&section_id=${s}`,
        r = await fetch(o);
      if (!r.ok) throw new Error(`Failed to fetch three cards section: ${r.statusText}`);
      const a = await r.text(),
        d = new DOMParser().parseFromString(a, "text/html").querySelector(".three-cards-main-block");
      if (!d) return;
      typeof ScrollTrigger < "u" &&
        ScrollTrigger.getAll().forEach((p) => {
          const m = p.trigger;
          m && e.contains(m) && p.kill();
        }),
        (e.innerHTML = d.innerHTML),
        setTimeout(() => {
          this._reinitializeThreeCardsScripts(e);
        }, 0);
    } catch (e) {
      console.error("Error updating three cards section:", e);
    }
  }
  _reinitializeThreeCardsScripts(t) {
    if (!t) return;
    const e = t.querySelectorAll(".card-item"),
      i = t.querySelector("#how-to-title");
    !i ||
      !e.length ||
      (typeof gsap < "u" &&
        gsap.to(i, {
          scale: 1,
          ease: "power2.out",
          scrollTrigger: { trigger: t, start: "top bottom", end: "bottom top", scrub: !0 },
        }),
      typeof ScrollTrigger < "u" &&
        ScrollTrigger.matchMedia({
          "(max-width: 767px)": () => {
            var r;
            const s = (r = e[0]) == null ? void 0 : r.offsetHeight;
            if (!s) return;
            const n = s / window.innerHeight,
              o = gsap.timeline({
                scrollTrigger: { trigger: t, start: "top top+=64", end: "+=" + e.length * s * 1.5, scrub: !0, pin: !0 },
              });
            e.forEach((a, l) => {
              l > 0 && a.setAttribute("aria-hidden", "true"),
                o.fromTo(
                  a,
                  { y: 1200, scale: 0.8 },
                  {
                    y: 0,
                    opacity: 1,
                    scale: 1,
                    ease: "power3.out",
                    duration: n,
                    onStart: () => {
                      l > 0 && a.removeAttribute("aria-hidden");
                    },
                  },
                  l * n
                );
            });
          },
          "(min-width: 768px) and (max-width: 1023px)": () => {
            var r;
            const s = (r = e[0]) == null ? void 0 : r.offsetHeight;
            if (!s) return;
            const n = s / window.innerHeight,
              o = gsap.timeline({
                scrollTrigger: {
                  trigger: t,
                  start: "top top+=104",
                  end: "+=" + e.length * s * 1.5,
                  scrub: !0,
                  pin: !0,
                },
              });
            e.forEach((a, l) => {
              l > 0 && a.setAttribute("aria-hidden", "true"),
                o.fromTo(
                  a,
                  { y: 1200, scale: 0.8 },
                  {
                    y: 0,
                    opacity: 1,
                    scale: 1,
                    ease: "power3.out",
                    duration: n,
                    onStart: () => {
                      l > 0 && a.removeAttribute("aria-hidden");
                    },
                  },
                  l * n
                );
            });
          },
          "(min-width: 1024px)": () => {
            var r;
            const s = (r = e[0]) == null ? void 0 : r.offsetHeight;
            if (!s) return;
            const n = s / window.innerHeight,
              o = gsap.timeline({
                scrollTrigger: { trigger: t, start: "top top", end: "+=" + e.length * s * 1.5, scrub: !0, pin: !0 },
              });
            e.forEach((a, l) => {
              l > 0 && a.setAttribute("aria-hidden", "true"),
                o.fromTo(
                  a,
                  { y: 800, scale: 0.8 },
                  {
                    y: 0,
                    opacity: 1,
                    scale: 1,
                    ease: "power3.out",
                    duration: n,
                    onStart: () => {
                      l > 0 && a.removeAttribute("aria-hidden");
                    },
                  },
                  l * n
                );
            });
          },
        }));
  }
}
customElements.define("product-variants", k);
class O extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.inputElement = this.querySelector("input")),
      (this.decrementButton = this.querySelector("button[name='minus']")),
      (this.incrementButton = this.querySelector("button[name='plus']")),
      this._checkQuantity(),
      this.decrementButton.addEventListener("click", () => {
        (this.inputElement.quantity = this.inputElement.quantity - 1), this._checkQuantity(), this._syncOthers();
      }),
      this.incrementButton.addEventListener("click", () => {
        (this.inputElement.quantity = this.inputElement.quantity + 1), this._checkQuantity(), this._syncOthers();
      });
  }
  _checkQuantity() {
    this.inputElement.value == this.inputElement.max
      ? this.incrementButton.classList.add("is-disabled")
      : this.incrementButton.classList.remove("is-disabled"),
      this.inputElement.value == this.inputElement.min
        ? this.decrementButton.classList.add("is-disabled")
        : this.decrementButton.classList.remove("is-disabled");
  }
  get quantity() {
    return this.inputElement.quantity;
  }
  set quantity(t) {
    (this.inputElement.quantity = t), this._checkQuantity();
  }
  get min() {
    return this.inputElement.min;
  }
  set min(t) {
    (this.inputElement.min = t), this.quantity < t ? (this.quantity = t) : this._checkQuantity();
  }
  get max() {
    return this.inputElement.max;
  }
  set max(t) {
    (this.inputElement.max = t), this.quantity > t ? (this.quantity = t) : this._checkQuantity();
  }
  _syncOthers() {
    const t = this.dataset.formId;
    t &&
      document.querySelectorAll(`quantity-selector[data-form-id="${t}"]`).forEach((e) => {
        e !== this && (console.log("el===", this.quantity), (e.quantity = this.quantity), (e.value = this.quantity));
      });
  }
}
customElements.define("quantity-selector", O);
class x extends b {
  constructor() {
    super();
  }
  connectedCallback() {
    super.init(),
      (this.swatches = this.querySelectorAll("[data-selling-plan-swatch]")),
      (this.subscriptionOffer = this.querySelector("[data-subscription-offer]")),
      (this.subscriptionPrice = this.subscriptionOffer.querySelector("[data-price]")),
      (this.subscriptionCompareAtPrice = this.subscriptionOffer.querySelector("[data-compare-at-price]")),
      (this.subscriptionDiscount = this.querySelector("[data-subscription-offer] [data-discount]")),
      (this.oneTimeOffer = this.querySelector("[data-one-time-offer]")),
      (this.oneTimePrice = this.oneTimeOffer.querySelector("[data-price]")),
      (this.oneTimeCompareAtPrice = this.oneTimeOffer.querySelector("[data-compare-at-price]")),
      (this.selectedOfferType = this.querySelector("[name='subscription']:checked").dataset.offerType),
      this.querySelectorAll("[name='subscription']").forEach((t) =>
        t.addEventListener("change", this._onOfferChanged.bind(this))
      ),
      this.querySelectorAll("[name='selling_plan']").forEach((t) =>
        t.addEventListener("change", this._onSellingPlanChanged.bind(this))
      ),
      this.form && this.form.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  _onOfferChanged(t) {
    this.selectedOfferType = t.currentTarget.dataset.offerType;
    let e = null;
    switch (this.selectedOfferType) {
      case "one-time":
        this.form.selling_plan.forEach((i) => (i.disabled = !0)), this._updateUrl();
        break;
      case "subscription":
        this.form.selling_plan.forEach((i) => (i.disabled = !1)),
          this._updateUrl(this.selectedSellingPlan.selling_plan_id),
          (e = this.selectedSellingPlan);
        break;
    }
    this.form.dispatchEvent(new CustomEvent("selling-plan:changed", { bubbles: !1, detail: { newSellingPlan: e } }));
  }
  _onSellingPlanChanged(t) {
    this._updateUrl(this.selectedSellingPlan.selling_plan_id),
      this._updateSubscriptionPrice(),
      this.form.dispatchEvent(
        new CustomEvent("selling-plan:changed", { bubbles: !1, detail: { newSellingPlan: this.selectedSellingPlan } })
      );
  }
  _onVariantChanged(t) {
    if (
      (this.swatches.forEach((i, s) => {
        var n, o;
        this.form.selling_plan[s].value ==
        ((o = (n = this.selectedVariant.selling_plan_allocations) == null ? void 0 : n[s]) == null
          ? void 0
          : o.selling_plan_id)
          ? (i.classList.remove("jc-hidden"), (this.form.selling_plan[s].disabled = !1))
          : (i.classList.add("jc-hidden"),
            (this.form.selling_plan[s].checked = !1),
            (this.form.selling_plan[s].disabled = !0));
      }),
      !this.querySelector("[name='selling_plan']:checked"))
    ) {
      const i = this.querySelector("[name='selling_plan']:not(:disabled)");
      i && ((i.checked = !0), this._updateUrl(i.value));
    }
    this._updateSubscriptionPrice(), this._updateOneTimePrice();
    let e = this.selectedOfferType == "one-time" ? null : this.selectedSellingPlan;
    this.form.dispatchEvent(new CustomEvent("selling-plan:changed", { bubbles: !1, detail: { newSellingPlan: e } }));
  }
  _updateUrl(t) {
    if (this.updateUrl && history.replaceState) {
      const e = new URL(window.location.href);
      t ? e.searchParams.set("selling_plan", t) : e.searchParams.set("selling_plan", "one-time"),
        window.history.replaceState({ path: e.toString() }, "", e.toString());
    }
  }
  _updateSubscriptionPrice() {
    const t = this.selectedSellingPlan.price,
      e = this.selectedSellingPlan.compare_at_price;
    (this.subscriptionPrice.innerHTML = f(t)),
      e > t
        ? ((this.subscriptionCompareAtPrice.innerHTML = f(e)),
          this.subscriptionOffer.classList.add("jc-compare-at-price"),
          this.subscriptionDiscount && (this.subscriptionDiscount.innerHTML = Math.floor(100 - (t / e) * 100) + "%"))
        : this.subscriptionOffer.classList.remove("jc-compare-at-price");
  }
  _updateOneTimePrice() {
    const t = this.selectedVariant.price,
      e = this.selectedVariant.compare_at_price;
    (this.oneTimePrice.innerHTML = f(t)),
      e > t
        ? (this.oneTimeOffer.classList.add("jc-compare-at-price"), (this.oneTimeCompareAtPrice.innerHTML = f(e)))
        : this.oneTimeOffer.classList.remove("jc-compare-at-price");
  }
  get selectedSellingPlan() {
    return this._getSellingPlanById(this.form.selling_plan.value);
  }
  _getSellingPlanById(t) {
    return this.selectedVariant.selling_plan_allocations.find((e) => e.selling_plan_id == t);
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
}
customElements.define("subscription-block", x);
class I extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let t = this.getAttribute("data-form-id");
    this.form = document.getElementById(t);
    const e = document.querySelector(`product-variants[data-form-id='${t}']`);
    (this.sectionId = e == null ? void 0 : e.dataset.sectionId),
      this.form && this.form.addEventListener("variant:changed", this._onVariantChanged.bind(this)),
      this._setupVisibilityObserver(),
      this._addPaddingToBodyTag();
  }
  _onVariantChanged(t) {
    const e = t.detail.variant;
    this._fetchStickyAtcData(e == null ? void 0 : e.id), this._updateMedia(e);
  }
  async _fetchStickyAtcData(t) {
    var e, i, s, n;
    try {
      const o = (i = (e = this.form) == null ? void 0 : e.handle) == null ? void 0 : i.value,
        r = this.sectionId;
      if (!o || !r || !t) return;
      const a = ((n = (s = this.form) == null ? void 0 : s.selling_plan) == null ? void 0 : n.value) || "one-time",
        l = `${window.Shopify.routes.root}products/${o}?variant=${t}&section_id=${r}&selling_plan=${a}`,
        h = await fetch(l);
      if (!h.ok) throw new Error(`Failed to fetch sticky ATC section: ${h.status} ${h.statusText}`);
      const d = await h.text(),
        g = new DOMParser().parseFromString(d, "text/html").querySelector("[data-sticky-checked-options]"),
        u = this.querySelector("[data-sticky-checked-options]");
      g && u && (u.innerHTML = g.innerHTML);
    } catch (o) {
      console.error("ProductStickyAtc: error updating sticky checked options", o);
    }
  }
  _updateMedia(t) {
    var n;
    const e = (n = t == null ? void 0 : t.featured_media) == null ? void 0 : n.id;
    if (!e) return;
    const i = this.querySelectorAll("[data-sticky-media-id]"),
      s = this.querySelector(`[data-sticky-media-id^="${e}"]`);
    s &&
      (i.forEach((o) => {
        o.classList.remove("active");
      }),
      s.classList.add("active"));
  }
  set toggleBarVisibility(t) {
    this.classList.toggle("active", !t);
  }
  _setupVisibilityObserver() {
    const t = this.form;
    if (!t) return;
    const e = { rootMargin: "0px" };
    (this.intersectionObserver = new IntersectionObserver((i) => {
      i.forEach((s) => {
        if (s.target === t) {
          const n = t.getBoundingClientRect();
          this._isPaymentContainerPassed = s.intersectionRatio === 0 && n.top + n.height <= 0;
        }
      }),
        (this.toggleBarVisibility = !this._isPaymentContainerPassed);
    })),
      this.intersectionObserver.observe(t, e);
  }
  _addPaddingToBodyTag() {
    const t = this.offsetHeight;
    t > 0 && (document.body.style.paddingBottom = `${t}px`);
  }
}
customElements.define("product-sticky-atc", I);
class q extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.swiper = this.querySelector("#productMainSwiper").swiper), (this.layoutType = this.dataset.layout);
    const t = document.getElementById(this.getAttribute("data-form-id"));
    t && t.addEventListener("variant:changed", this._onVariantChanged.bind(this)),
      this.addStickyClass(),
      window.addEventListener("resize", this.addStickyClass);
  }
  addStickyClass() {
    let t,
      e,
      i = 0;
    const s = document.querySelector(".announcement-bar"),
      n = document.querySelector("header");
    s && ((t = s.offsetHeight), (i += t)),
      n && ((e = n.offsetHeight), (t += e)),
      document.querySelectorAll("[data-sticky]").forEach((r) => {
        r.style.top = i + "px";
      });
  }
  _onVariantChanged(t) {
    var a;
    const e = t.detail.variant,
      i = (a = e == null ? void 0 : e.featured_media) == null ? void 0 : a.id;
    if (!i) return;
    const n = this.querySelector(`[data-swiper-media-id^="${i}"]`).dataset.swiperMediaIndex;
    if ((this.swiper.slideToLoop(n, 500), !this.layoutType.includes("grid"))) return;
    const o = this.querySelectorAll("[data-grid-media-id]"),
      r = this.querySelector(`[data-grid-media-id^="${i}"]`);
    r &&
      (o.forEach((l) => {
        l.classList.remove("active");
      }),
      r.classList.add("active"));
  }
}
customElements.define("product-gallery", q);
class M extends HTMLDialogElement {
  constructor() {
    super(), this.addEventListener("click", this._handleOutsideClosing.bind(this));
  }
  connectedCallback() {
    this._handleInsideClosing();
  }
  showModal(...t) {
    return (
      this.setAttribute("aria-expanded", "true"),
      (document.documentElement.style.overflow = "hidden"),
      super.showModal(...t)
    );
  }
  close(...t) {
    return (
      this.setAttribute("aria-expanded", "false"), (document.documentElement.style.overflow = ""), super.close(...t)
    );
  }
  _handleInsideClosing() {
    this.querySelectorAll("[data-close]").forEach((t) => {
      t.addEventListener("click", () => this.close());
    });
  }
  _handleOutsideClosing(t) {
    const e = this.getBoundingClientRect();
    (e.top <= t.clientY && t.clientY <= e.top + e.height && e.left <= t.clientX && t.clientX <= e.left + e.width) ||
      this.close();
  }
}
customElements.define("dialog-box", M, { extends: "dialog" });
class P extends HTMLButtonElement {
  constructor() {
    super(), (this.handleClick = this._openDialog.bind(this));
  }
  connectedCallback() {
    if (!this.dataset.openDialog) {
      console.warn("dialogBoxTrigger: No dialog ID provided.");
      return;
    }
    if (
      ((this.dialogId = this.dataset.openDialog), (this.dialog = document.getElementById(this.dialogId)), !this.dialog)
    ) {
      console.error(`dialogBoxTrigger: No dialog found with ID "${this.dialogId}".`);
      return;
    }
    this.addEventListener("click", this.handleClick);
  }
  _openDialog() {
    this.dialog.showModal();
  }
}
customElements.define("dialog-box-trigger", P, { extends: "button" });
class B extends HTMLElement {
  constructor() {
    super(),
      (this.CONSTANTS = {
        SELECTORS: {
          SWIPER_CONTAINER: ".swiper",
          OPEN_TRIGGERS: "[data-lightbox-open]",
          CLOSE_TRIGGERS: "[data-lightbox-close]",
          MEDIA_ELEMENTS: "[data-swiper-media-id]",
        },
        DATA_ATTRIBUTES: { ZOOM_ACTIVE: "data-zoom-active", OPEN: "data-lightbox-open" },
        DEFAULT_ZOOM: { X: "50%", Y: "50%" },
        TOUCH: { MAX_ZOOM: 100, MIN_ZOOM: 0 },
        TRANSITION_DURATION: 500,
      }),
      (this._touchState = null),
      (this._lastMousePosition = null),
      (this._isAnimating = !1),
      (this.handleMouseMove = this.handleMouseMove.bind(this)),
      (this.mobileTouchStart = this.mobileTouchStart.bind(this)),
      (this.mobileTouchMove = this.mobileTouchMove.bind(this)),
      (this.mobileTouchEnd = this.mobileTouchEnd.bind(this)),
      (this.openLightBox = this.openLightBox.bind(this)),
      (this.closeLightBox = this.closeLightBox.bind(this)),
      (this.toggleZoom = this.toggleZoom.bind(this));
  }
  connectedCallback() {
    this._initializeElements(), this._initializeSwiper(), this._attachEventListeners(), this._setupKeyboardNavigation();
  }
  _initializeElements() {
    try {
      if (
        ((this.openTriggers = document.querySelectorAll(this.CONSTANTS.SELECTORS.OPEN_TRIGGERS)),
        (this.closeTriggers = this.querySelectorAll(this.CONSTANTS.SELECTORS.CLOSE_TRIGGERS)),
        (this.mediaElements = this.querySelectorAll(this.CONSTANTS.SELECTORS.MEDIA_ELEMENTS)),
        !this.openTriggers.length || !this.closeTriggers.length || !this.mediaElements.length)
      )
        throw new Error("Required elements not found");
    } catch (t) {
      console.error("Failed to initialize LightBox elements:", t);
    }
  }
  _initializeSwiper() {
    const t = this.querySelector(this.CONSTANTS.SELECTORS.SWIPER_CONTAINER);
    if (!t) {
      console.warn("Swiper container not found");
      return;
    }
    this.swiper = new v(t, {
      slidesPerView: 1,
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", enabled: !0, hideOnClick: !1 },
      on: { beforeTransitionStart: this._handleSwiperTransition.bind(this) },
    });
  }
  _attachEventListeners() {
    this.openTriggers.forEach((t) => t.addEventListener("click", this.openLightBox)),
      this.closeTriggers.forEach((t) => t.addEventListener("click", this.closeLightBox)),
      this.mediaElements.forEach((t) => t.addEventListener("click", this.toggleZoom));
  }
  _handleSwiperTransition(t) {
    var i;
    const e = (i = t.slides[t.activeIndex]) == null ? void 0 : i.querySelector(this.CONSTANTS.SELECTORS.MEDIA_ELEMENTS);
    if (!e) {
      console.warn("No media element found in swiper slide");
      return;
    }
    this._resetZoomState(e);
  }
  _resetZoomState(t) {
    t.removeAttribute(this.CONSTANTS.DATA_ATTRIBUTES.ZOOM_ACTIVE),
      t.style.setProperty("--zoom-x", this.CONSTANTS.DEFAULT_ZOOM.X),
      t.style.setProperty("--zoom-y", this.CONSTANTS.DEFAULT_ZOOM.Y),
      this._detachZoomListeners(t);
  }
  toggleZoom(t) {
    const e = t.currentTarget;
    e.hasAttribute(this.CONSTANTS.DATA_ATTRIBUTES.ZOOM_ACTIVE) ? this._deactivateZoom(e) : this._activateZoom(t, e);
  }
  _activateZoom(t, e) {
    const i = e.getBoundingClientRect(),
      s = ((t.clientX - i.left) / i.width) * 100,
      n = ((t.clientY - i.top) / i.height) * 100;
    this._setZoomPosition(e, s, n),
      e.setAttribute(this.CONSTANTS.DATA_ATTRIBUTES.ZOOM_ACTIVE, ""),
      this._attachZoomListeners(e);
  }
  _deactivateZoom(t) {
    t.removeAttribute(this.CONSTANTS.DATA_ATTRIBUTES.ZOOM_ACTIVE),
      this._detachZoomListeners(t),
      this._setZoomPosition(t, 50, 50);
  }
  _setZoomPosition(t, e, i) {
    t.style.setProperty("--zoom-x", `${e}%`), t.style.setProperty("--zoom-y", `${i}%`);
  }
  handleMouseMove(t) {
    const e = t.currentTarget;
    if (!e || !e.hasAttribute(this.CONSTANTS.DATA_ATTRIBUTES.ZOOM_ACTIVE)) return;
    const i = e.getBoundingClientRect(),
      s = ((t.clientX - i.left) / i.width) * 100,
      n = ((t.clientY - i.top) / i.height) * 100;
    this._setZoomPosition(e, s, n);
  }
  mobileTouchStart(t) {
    const e = t.currentTarget;
    if (!e.hasAttribute(this.CONSTANTS.DATA_ATTRIBUTES.ZOOM_ACTIVE) || t.touches.length !== 1) return;
    this.swiper.allowTouchMove = !1;
    const i = e.getBoundingClientRect(),
      s = parseFloat(getComputedStyle(e).getPropertyValue("--zoom-x"));
    this._touchState = { startX: t.touches[0].clientX, currentZoomX: s, targetWidth: i.width };
  }
  mobileTouchMove(t) {
    if (!t.currentTarget.hasAttribute(this.CONSTANTS.DATA_ATTRIBUTES.ZOOM_ACTIVE) || t.touches.length !== 1) return;
    t.preventDefault();
    const e = t.currentTarget,
      n = ((t.touches[0].clientX - this._touchState.startX) / this._touchState.targetWidth) * 100,
      o = Math.min(
        this.CONSTANTS.TOUCH.MAX_ZOOM,
        Math.max(this.CONSTANTS.TOUCH.MIN_ZOOM, this._touchState.currentZoomX - n)
      );
    this._setZoomPosition(e, o, 50);
  }
  mobileTouchEnd(t) {
    (this.swiper.allowTouchMove = !0), (this._touchState = null);
  }
  openLightBox(t) {
    const e = t.currentTarget.dataset.swiperSlideIndex;
    if (!this.swiper) {
      console.warn("Swiper is undefined in Lightbox");
      return;
    }
    document.body.setAttribute(this.CONSTANTS.DATA_ATTRIBUTES.OPEN, ""),
      (this.dataset.open = "true"),
      this.swiper.slideTo(e, this.CONSTANTS.TRANSITION_DURATION, !0);
  }
  closeLightBox() {
    document.body.removeAttribute(this.CONSTANTS.DATA_ATTRIBUTES.OPEN), (this.dataset.open = "false");
  }
  _attachZoomListeners(t) {
    t.addEventListener("mousemove", this.handleMouseMove),
      t.addEventListener("touchstart", this.mobileTouchStart, { passive: !1 }),
      t.addEventListener("touchmove", this.mobileTouchMove, { passive: !1 }),
      t.addEventListener("touchend", this.mobileTouchEnd);
  }
  _detachZoomListeners(t) {
    t.removeEventListener("mousemove", this.handleMouseMove),
      t.removeEventListener("touchstart", this.mobileTouchStart),
      t.removeEventListener("touchmove", this.mobileTouchMove),
      t.removeEventListener("touchend", this.mobileTouchEnd);
  }
  _setupKeyboardNavigation() {
    document.addEventListener("keydown", this._handleKeyDown.bind(this));
  }
  _handleKeyDown(t) {
    var e, i;
    if (!this.dataset.open !== "true")
      switch (t.key) {
        case "Escape":
          this.closeLightBox();
          break;
        case "ArrowLeft":
          (e = this.swiper) == null || e.slidePrev();
          break;
        case "ArrowRight":
          (i = this.swiper) == null || i.slideNext();
          break;
      }
  }
  _cleanup() {
    var t, e, i, s;
    (t = this.openTriggers) == null || t.forEach((n) => n.removeEventListener("click", this.openLightBox)),
      (e = this.closeTriggers) == null || e.forEach((n) => n.removeEventListener("click", this.closeLightBox)),
      (i = this.mediaElements) == null || i.forEach((n) => n.removeEventListener("click", this.toggleZoom)),
      document.removeEventListener("keydown", this._handleKeyDown),
      (s = this.swiper) == null || s.destroy(!0, !0);
  }
  disconnectedCallback() {
    this._cleanup();
  }
}
customElements.define("light-box", B);
class D extends HTMLElement {
  constructor() {
    super(),
      (this.tabs = Array.from(this.querySelectorAll("[data-tab]"))),
      (this.contentEntries = Array.from(this.querySelectorAll("[data-content-entry]")));
  }
  connectedCallback() {
    var t;
    if (!this.tabs) {
      console.warn("Missing tabs in <info-tabs>");
      return;
    }
    if (!this.contentEntries) {
      console.warn("Missing content entries in <info-tabs>");
      return;
    }
    (this.tabSwitchClickedHandler = this.handleTabSwitchClicked.bind(this)),
      this.tabs.forEach((e) => e.addEventListener("click", this.tabSwitchClickedHandler)),
      (t = this.tabs.at(0)) == null || t.dispatchEvent(new MouseEvent("click"));
  }
  handleTabSwitchClicked(t) {
    if (t.currentTarget !== t.target) return;
    const e = t.currentTarget,
      i = this.tabs.indexOf(e);
    this.tabs.forEach((r) => {
      r.removeAttribute("data-prev"), r.removeAttribute("data-next");
    }),
      this.contentEntries.forEach((r) => {
        r.removeAttribute("data-active");
      });
    const s = this.tabs[i + 1],
      n = this.tabs[i - 1],
      o = this.contentEntries.find((r) => r.dataset.id === e.dataset.id);
    n && n.setAttribute("data-prev", ""), s && s.setAttribute("data-next", ""), o && o.setAttribute("data-active", "");
  }
  disconnectedCallback() {
    this.tabs.forEach((t) => t.removeEventListener("click", this.tabSwitchClickedHandler));
  }
}
customElements.define("info-tabs", D);
